import { render, staticRenderFns } from "./expense-sale-point.vue?vue&type=template&id=a7984c7a&"
import script from "./expense-sale-point.vue?vue&type=script&lang=js&"
export * from "./expense-sale-point.vue?vue&type=script&lang=js&"
import style0 from "./expense-sale-point.vue?vue&type=style&index=0&id=a7984c7a&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports